import React from 'react';
import ReactDOM from 'react-dom/client';
import { Amplify, I18n } from 'aws-amplify';
import { Authenticator } from '@aws-amplify/ui-react';
import { LicenseManager } from 'ag-grid-enterprise';
import axios from 'axios';
import App from './App';
import './index.css';
import Header from './components/CustomAuth/Header';
import Footer from './components/CustomAuth/Footer';
import '@aws-amplify/ui-react/styles.css';
import { createSwatches } from './services/ColorScaleCreation'

const getConfig = async () =>{
  const config = await axios.get('/config.json')
  Amplify.configure(config?.data?.Amplify);
  return config;
}

const _config = await getConfig();

const root = ReactDOM.createRoot(document.getElementById('root'));

if (_config.data?.ApplicationNameParameter) {
  document.title = _config?.data?.ApplicationNameParameter;
}
if (_config?.data?.PrimaryColorParameter && _config?.data?.PrimaryColorParameter !== '') {
  const colors = createSwatches({value: _config?.data?.PrimaryColorParameter, valueStop:600})
  colors.forEach((x) => {
    document.documentElement?.style?.setProperty(`--primary-color-${x.stop}`, `hsl(${x.h} ${x.s}% ${x.l}%)`);
  })
} else {
  const colors = createSwatches({value: "#012497", valueStop:600})
  colors.forEach((x) => {
    document.documentElement?.style?.setProperty(`--primary-color-${x.stop}`, `hsl(${x.h} ${x.s}% ${x.l}%)`);
  })
}
if (_config?.data?.SecondaryColorParameter) {
  const colors = createSwatches({value: _config?.data?.SecondaryColorParameter, valueStop:600})
  colors.forEach((x) => {
    document.documentElement?.style?.setProperty(`--secondary-color-${x.stop}`, `hsl(${x.h} ${x.s}% ${x.l}%)`);
  })
} 
// else {
  // const colors = createSwatches({value: "#012497", valueStop:600})
  // colors.forEach((x) => {
  //   document.documentElement?.style?.setProperty(`--secondary-color-${x.stop}`, `hsl(${x.h} ${x.s}% ${x.l}%)`);
  // })
// }

//changes the text displayed on the sign-in screen to remove any reference to username and replace it with email
I18n.putVocabulariesForLanguage('en', {
  "Send code": "Reset your password",
  "Resend code": "Resend Temporary Password",
  "Code": "Temporary Password",
  "Given Name": "First Name",
  "Family Name": "Last Name"
});

LicenseManager.setLicenseKey("undefined_MTcxNDYwNDQwMDAwMA==94769b6967511ffbc1ae7da9c6ae84fb");

//eslint-disable-next-line
let thissolvesaweirdproblemwithvite = import.meta.env;

root.render(
  import.meta?.env?.VITE_ANONYMOUS ==="true" ? <App config={_config?.data}/>
	  : <Authenticator
        loginMechanisms={['email']}
        hideSignUp={true}
        components={{ 
          Header() { return (<Header config={_config}/>)},
          Footer() { return (<Footer config={_config}/>)},
        }}
      >
        {(props) => <App {...props} config={_config?.data}/>}
      </Authenticator>
);